import axios from 'axios'
import _ from 'lodash'
import { get, post } from './base'

let getAllSource = axios.CancelToken.source()
let getByIdSource = axios.CancelToken.source()
let updateCustomFieldsSource = axios.CancelToken.source()

const v3EndPoint = '/api/v3/tasks'

export function getById(id) {
  getByIdSource.cancel('Cancel old get task by ID request')
  getByIdSource = axios.CancelToken.source()

  return get(`/api/v4/Tasks/${id}`, { cancelToken: getByIdSource.token })
}

export function getAll() {
  getAllSource.cancel('Cancel old get tasks request')
  getAllSource = axios.CancelToken.source()

  return get(v3EndPoint, { cancelToken: getAllSource.token })
}

export function updateCustomFields(id, customFields) {
  updateCustomFieldsSource.cancel('Cancel old custom fields update request')
  updateCustomFieldsSource = axios.CancelToken.source()

  return post(`/api/v4/tasks/${id}/custom-fields`, {
    cancelToken: updateCustomFieldsSource.token,
    data: {
      activity_id: id,
      custom_fields_schema: customFields,
    },
  }).catch((error) => {
    console.log(error)
    if (error.response?.status === 400) {
      // parse the error message to get the validation details
      // return it as a single array of error messages under the errors key.
      return {
        errors: _.uniq(
          Object.keys(error.response.data.errors)
            .map((key) => error.response.data.errors[key])
            .reduce((acc, val) => acc.concat(val), []),
        ),
      }
    }
  })
}
